import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated="June 2026">
      <p className="text-[15px] text-slate-600 leading-relaxed">
        These Terms &amp; Conditions govern your use of the SML Municipal Consulting website and the services we provide.
        By using our website or engaging our services, you agree to these terms.
      </p>

      <LegalSection heading="1. Our Services">
        <p>SML Municipal Consulting assists clients with municipal account management, billing dispute investigation,
        metering services, clearance applications, new account and account closure applications, refund applications and
        related matters. We act as a professional intermediary between the client and the relevant municipality or
        utility provider.</p>
      </LegalSection>

      <LegalSection heading="2. No Guarantee of Outcomes">
        <p>We assist, investigate, manage, facilitate, follow up on and work towards the resolution of municipal matters.
        We do not guarantee any specific outcome, refund, correction, clearance or municipal turnaround time, as these
        depend on the relevant municipality or utility provider and factors outside our control.</p>
      </LegalSection>

      <LegalSection heading="3. No Affiliation With Municipalities">
        <p>SML Municipal Consulting is an independent consulting business. We are not part of, and do not officially
        represent, any municipality or utility provider, and we do not claim any partnership or endorsement unless
        specifically confirmed in writing.</p>
      </LegalSection>

      <LegalSection heading="4. Client Responsibilities">
        <p>You agree to provide accurate and complete information and any authorisation reasonably required for us to
        act on your behalf. Delays or inaccuracies in the information provided may affect our ability to assist.</p>
      </LegalSection>

      <LegalSection heading="5. Fees">
        <p>Service packages and fees are set out on our website or in a quotation provided to you. Monthly account
        management packages are billed monthly. Specific scopes and fees will be confirmed with you before commencement.</p>
      </LegalSection>

      <LegalSection heading="6. Limitation of Liability">
        <p>To the maximum extent permitted by law, SML Municipal Consulting shall not be liable for any indirect or
        consequential loss arising from the use of our website or services, or from decisions or actions taken by any
        municipality or utility provider.</p>
      </LegalSection>

      <LegalSection heading="7. Governing Law">
        <p>These terms are governed by the laws of the Republic of South Africa.</p>
      </LegalSection>
    </LegalLayout>
  );
}
